import StickyNav from '../components/StickyNav';
import QuickViewModal from '../components/QuickViewModal';
import { initMap } from '../components/CommunityMap';
import HFSPanels from '../components/HFSPanels';
import Panels from '../components/Panels';
import { initCommunityPhotoSlideShows } from '../components/CommunityPhotoSlideshow';
import LightBox from '../components/LightBox';
import HFSGridFilter from '../components/HFSGridFilter';
import PlatMap from '../components/PlatMapPopup';

document.addEventListener('DOMContentLoaded', () => {
  //sticky nav init
  StickyNav().init();

  //quick view init
  const quickviewModal = QuickViewModal('js-quickview-modal');

  //init panels
  HFSPanels('js-hfs-panels');
  Panels('js-community-features-panels');
  Panels('js-community-location-panels');
  //init community slideshow
  initCommunityPhotoSlideShows();
  LightBox();
  new HFSGridFilter();
  new PlatMap();
});

window.addEventListener('load', () => {
  //initialize map
  initMap().catch(error => {
    console.error('Failed to initialize map:', error);
  });
});
